var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        fill: #eb008b;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 177,
    height: 38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22,37c6.74,0,12.21-5.47,12.21-12.21V1h-8.08v23.79c0,2.28-1.85,4.13-4.13,4.13v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.54,28.92v-2.92h-.1c-1.17,2.38-4.38,3.84-7.93,3.84-7.98,0-13.52-6.27-13.52-14.45S43.78,1,51.52,1c3.31,0,6.37,1.31,7.93,3.79h.1V1.92h8.07v27h-8.07Zm0-13.52c0-3.79-3.07-6.86-6.86-6.86s-6.62,3.06-6.62,6.95,2.97,6.81,6.71,6.81,6.76-3.02,6.76-6.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.32 28.92 140.33 22.07 135.35 28.92 125.67 28.92 135.49 15.42 125.67 1.92 135.35 1.92 155 28.92 145.32 28.92"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 148.5,
    cy: 6.03,
    r: 5.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m106.44,17.88c.44,3.06,3.02,5.11,6.32,5.11,2.19,0,3.6-.83,4.91-2.53h8.27c-2.58,5.89-7.49,9.34-13.18,9.34-7.78,0-14.3-6.27-14.3-14.3S104.69,1,112.62,1s14.25,6.37,14.25,14.74c0,.78-.05,1.41-.2,2.14h-20.24Zm12.36-5.45c-.63-2.77-3.07-4.62-6.18-4.62-2.92,0-5.45,1.75-6.08,4.62h12.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.32 35.56 85.79 35.56 98.43 1.92 89.87 1.92 84.71 17.59 84.62 17.59 79.22 1.92 70.6 1.92 80.63 27.56 77.32 35.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.200394af2d1e7af52055fd7552ba4741.svg";
export { ForwardRef as ReactComponent };